import React from 'react';

import './InviteSplash.scss';

function InviteSplash() {
  return (
    <div className={'invite-splash'}>
      <div className={'invite-splash__info'}></div>
    </div>
  );
}

export default InviteSplash;
